import { GiphyFetch } from '@giphy/js-fetch-api';
export const Giphy = apiKey => new GiphyFetch(apiKey);
export const getGifUrl = (gif) => gif.images.fixed_height.url || gif.images.original.url;
export const GiphyLogo = {
    light: 'https://tribe-s3-production.imgix.net/aW8qYOOWNr2soPXvieoBn?w=1000&auto=compress,format',
    dark: 'https://tribe-s3-production.imgix.net/mFnke0oJWTh5xtnBUtz58?w=1000&auto=compress,format',
};
//# sourceMappingURL=giphy.js.map